import Colors from '@root/joinroot.com/src/utils/colors';
import GatsbyLink from '@root/joinroot.com/src/components/core/link';
import Responsive from '@root/core/src/utils/responsive';
import styled from '@root/vendor/@emotion/styled';
import { regular, semiBold } from '@root/brand/src/assets/fonts/root-sans/emotion';

export const H1Display = styled.h1({
  ...semiBold(),
  color: Colors.nearBlack(),
  fontSize: 42,
  letterSpacing: '-0.02em',
  lineHeight: '110%',

  ...Responsive.md({
    fontSize: 66,
    lineHeight: '100%',
  }),
});

export const H2 = styled.h2({
  ...semiBold(),
  color: Colors.nearBlack(),
  fontSize: 28,
  letterSpacing: '-0.01em',
  lineHeight: '110%',

  ...Responsive.md({
    fontSize: 32,
  }),
});

export const H3 = styled.h3({
  ...semiBold(),
  color: Colors.nearBlack(),
  fontSize: 25,
  letterSpacing: '-0.01em',
  lineHeight: '110%',

  ...Responsive.md({
    fontSize: 28,
  }),
});

export const H4 = styled.h4({
  ...semiBold(),
  color: Colors.nearBlack(),
  fontSize: 22,
  letterSpacing: '-0.01em',
  lineHeight: '130%',

  ...Responsive.md({
    fontSize: 25,
  }),
});

export const H5 = styled.h5({
  ...regular(),
  color: Colors.nearBlack(),
  fontSize: 20,
  letterSpacing: '-0.015em',
  lineHeight: '130%',
});

export const Eyebrow = styled(H5)();

export const Subhead = styled(H5)({
  color: Colors.grayDark(),
});

export const P1 = styled.p({
  ...regular(),
  whiteSpace: 'pre-wrap',
  color: Colors.grayMedium(),
  fontSize: 18,
  letterSpacing: '-0.015em',
  lineHeight: '130%',
});

export const P2 = styled.p({
  ...regular(),
  whiteSpace: 'pre-wrap',
  color: Colors.grayMedium(),
  fontSize: 14,
  letterSpacing: '-0.015em',
  lineHeight: '130%',
});

const linkActionColors = {
  rootOrangePressed: () => '#F08E65',
  rootOrangeDisabled: () => '#DADADA',
};

export const Link = styled(GatsbyLink)({
  ...regular(),
  color: Colors.nearBlack(),
  cursor: 'pointer',
  fontSize: 18,
  letterSpacing: '-0.015em',
  lineHeight: '130%',
  textDecoration: 'underline',
  transition: '150ms ease-in-out',

  '&:hover': {
    color: Colors.rootOrange(),
  },

  '&:focus': {},

  '&:active': {
    color: linkActionColors.rootOrangePressed(),
  },
});

export const UL = styled.ul({
  color: Colors.nearBlack(),
  paddingLeft: 28,

  '& li p': {
    marginLeft: 4,
  },
});

export const OL = styled.ol({
  color: Colors.nearBlack(),
  paddingLeft: 28,

  '& li p': {
    marginLeft: 10,
  },
});

export const LI = styled.li({
  '& p': {
    margin: '10px 0',
  },
});

export const Blockquote = styled.blockquote({
  margin: '50px 0',
  padding: '0 0 0 20px',
  borderLeft: `1px solid ${Colors.rootOrange()}`,

  '& p:first-of-type': {
    color: Colors.nearBlack(),
  },
});
